import React from "react";
import { TrendingDown, TrendingUp } from "lucide-react";
import { tickerItems } from "./useLandingPage";
import "./MarketTicker.scss";

const MarketTicker: React.FC = () => {
  const doubled = [...tickerItems, ...tickerItems];

  return (
    <div className="ticker-bar overflow-hidden py-2.5">
      <div className="mx-auto max-w-7xl overflow-hidden px-3 sm:px-4 lg:px-8">
        <div className="eos-ticker-track">
          {doubled.map((item, index) => {
            const positive = item.change >= 0;
            const Icon = positive ? TrendingUp : TrendingDown;
            return (
              <div key={`${item.symbol}-${index}`} className="flex items-center gap-2 px-2 text-sm font-medium">
                <span className="text-slate-200">{item.symbol}</span>
                <span className={`flex items-center gap-1 ${positive ? "text-emerald-400" : "text-red-400"}`}>
                  <Icon className="h-3.5 w-3.5" />
                  {positive ? "+" : ""}
                  {item.change.toFixed(2)}%
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MarketTicker;
